import React, {
  createContext,
  useContext,
  useMemo,
} from 'react';

const StyleElementContext = createContext();

export const useStyleElement = () => useContext(StyleElementContext);

const StyleElementProvider = ({
  scrollSnap = null,
  styleElement = null,
  children,
}) => {
  const value = useMemo(() => ({
    scrollSnap,
    styleElement,
  }), [
    scrollSnap,
    styleElement,
  ]);

  return (
    <StyleElementContext.Provider value={value}>
      {children}
    </StyleElementContext.Provider>
  );
};

export default StyleElementProvider;
